import { createForm } from '@seek/forms-ui';
import { required } from '@seek/validators-js';
import {
  Stack,
  Heading,
  Card,
  Columns,
  Column,
  RadioGroup,
  RadioItem,
  TextField,
} from 'braid-design-system';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { useSubmit } from 'src/hooks/submit';
import type { StoreProps } from 'src/store';
import {
  submitOperationsDetails,
  type OperationsDetails,
} from 'src/store/calculatorForm';
import { withoutHighlight } from 'src/utils';

import NavigationButton from '../../tempComponents/NavigationButton/NavigationButton';
import SubmitButton from '../../tempComponents/SubmitButton/SubmitButton';

const FORM_NAME = 'operationsForm';

const { FormProvider, useField } = createForm<OperationsDetails>(FORM_NAME);

interface Props {
  handleSubmit: (_: any) => any;
}

const OperationsForm = ({ handleSubmit }: Props) => {
  const { submitStatus, submit } = useSubmit(submitOperationsDetails);

  const staff = withoutHighlight(
    useField({
      id: 'staff',
      validators: [required],
    }),
  );

  const working = withoutHighlight(
    useField({
      id: 'working',
      validators: [required],
    }),
  );

  const procedures = withoutHighlight(
    useField({
      id: 'procedures',
      validators: [required],
    }),
  );

  const experience = withoutHighlight(
    useField({
      id: 'experience',
      validators: [required],
    }),
  );

  return (
    <Card>
      <form onSubmit={handleSubmit(submit)}>
        <Stack space="large">
          <Heading weight="weak" level="3">
            Operations
          </Heading>

          <TextField
            id="staff"
            label="Number of Staff"
            placeholder="staff"
            data={{ testid: 'staff' }}
            tone={staff.valid ? 'neutral' : 'critical'}
            message={!staff.valid && staff.errorMessage}
            {...staff}
          />

          <RadioGroup
            id="working"
            label="Are you working in the business?"
            {...working}
          >
            <RadioItem label="Yes" value="true" />
            <RadioItem label="No" value="false" />
          </RadioGroup>

          <RadioGroup
            id="procedures"
            label="Do you have operating manuals and procedures?"
            {...procedures}
          >
            <RadioItem label="Yes" value="true" />
            <RadioItem label="No" value="false" />
          </RadioGroup>

          <RadioGroup
            id="experience"
            label="How experienced is your management team?"
            {...experience}
          >
            <RadioItem label="Very Experienced" value="1" />
            <RadioItem label="Somewhat Experienced" value="2" />
          </RadioGroup>

          <Columns space="none">
            <Column>
              <NavigationButton back={true} />
            </Column>
            <Column>
              <SubmitButton />
            </Column>
          </Columns>
        </Stack>
      </form>
      {submitStatus?.status === 'SUCCESS' && (
        <Navigate to="/price-guide/estimation" />
      )}
    </Card>
  );
};

const Operations = (props: any) => {
  const formVals = useSelector(
    ({ calculatorForm }: StoreProps) => calculatorForm,
  );
  return (
    // @ts-ignore
    <FormProvider initialValues={formVals}>
      {({ handleSubmit }) => (
        <OperationsForm {...props} handleSubmit={handleSubmit} />
      )}
    </FormProvider>
  );
};

export default Operations;
